export {
  cjrcLib
}

import { _BASIC_CONFIG } from './nfc_libs/basic_config.js';

//import {NFCPortLib, NFCPortError, Configuration, DetectionOption, CommunicationOption, TargetCard} from 'https://cdn.felica-support.sony.biz/webclient/trial/NFCPortLib.js';
//import { NFCPortLib, NFCPortError, Configuration, DetectionOption, CommunicationOption, TargetCard } from './nfc_libs/nfc_port_lib.js';
import { NFCPortLib, NFCPortError, Configuration, DetectionOption, CommunicationOption, TargetCard } from './NFCPortLib.js';
import { NFCUtils } from './nfc_libs/nfc_utils.js';

/// 日本鉄道サイバネティクス協議会（CJRC）規格
class cjrcLib {
  constructor () {
    this.systemCode = 0x0003
    this.card_type = 'iso18092'
    this.lib = new NFCPortLib()

    this.idm = 0x00
    this.pmm = 0x00
    this.pupi = 0x00

    this.ackTimeout = 500
    this.receiveTimeout = 500
    this.autoBaudRate = false
    this.autoDeviceSelect = false
    this.stationData = {}
    this.stationDataUrl = location.origin + location.pathname + 'resources/StationCode.csv'
  }
  //https://github.com/pcphashimoto/SuicaReader/blob/master/js/suica.js

  // !!!! NO ERROR HANDLING YET 2020.05.03 !!!!
  async _fetchStationData() {
    try {
      let res = await fetch(this.stationDataUrl)
      let res_text = await res.text()
      let res_array = res_text.split("\n")
      res_array.forEach( (item, key) => {
        if(key!=0) {
          let _si =item.split(',')
          _si.forEach( (data, idx) => {
            if(idx <= 3) {
              _si[idx] = _si[idx].toLocaleLowerCase()
            }
          })
          if(typeof this.stationData[_si[0]] == 'undefined') {
            this.stationData[_si[0]] = {}
          }
          if(typeof this.stationData[_si[0]][_si[1]] == 'undefined') {
            this.stationData[_si[0]][_si[1]] = {}
          }
          this.stationData[_si[0]][_si[1]][_si[2]] = {
            company: _si[3],
            line: _si[4],
            station: _si[5]
          }
        }
      })
    } catch(err) {
      console.error(err)
    }
  }

  // [StationCode.csv]
  // https://github.com/MasanoriYONO/StationCode/blob/master/StationCode.csv
  // https://github.com/m2wasabi/nfcpy-suica-sample/blob/master/StationCode.csv
  async convertHexStationInfoToText(region_code = null, line_code = null, station_code = null) {
    if(region_code == null
       || line_code ==null
       || station_code == null ) {
      return null
    }
    let rc = parseInt('0x'+region_code).toString(16)
    let lc = parseInt('0x'+line_code).toString(16)
    let sc = parseInt('0x'+station_code).toString(16)
    let station = null
    try {
      station = this.stationData[rc][lc][sc]
      if(typeof station == 'undefined') {
        station = { company: 'undefined', line: 'undefined', station: 'undefined' }
      }
    } catch(err) {
      station = null
    }
    return station
  }

  convertHextToDate(hexArray = []) {
    let __b = parseInt(`0x${hexArray.join('')}`)
    let yy = __b >> 9
    let mm = (__b >> 5) & 0xf
    let dd = __b & 0x1f
    return `${2000+yy}-${('00'+mm).substr(-2)}-${('00'+dd).substr(-2)}`
  }

  convertHexToString(type = null, num = null) {
    if(type == null || num == null) {
      return '--'
    }
    let suica = {
      machine : {
        '0x03' : "精算機",       // 3
        '0x04' : "携帯型端末",   // 4
        '0x05' : "車載端末",
        '0x07' : "券売機",       //7
        '0x08' : "券売機",
        '0x09' : "入金機",
        '0x12' : "券売機",       // 18
        '0x14' : "券売機等",     // 20
        '0x15' : "券売機等",
        '0x16' : "改札機",
        '0x17' : "簡易改札機",
        '0x18' : "窓口端末",
        '0x19' : "窓口端末",
        '0x1a' : "改札端末",
        '0x1b' : "携帯電話",
        '0x1c' : "乗継精算機",
        '0x1d' : "連絡改札機",   // 29
        '0x1f' : "簡易入金機",   // 31
        '0x46' : "VIEW ALTTE",   // 70
        '0x48' : "VIEW ALTTE",   // 72
        '0xc7' : "物販端末",     // 199
        '0xc8' : "自販機"        // 200
      },
      trans : {
        '0x01' : "運賃支払(改札出場)",
        '0x02' : "チャージ",
        '0x03' : "券購(磁気券購入)",
        '0x04' : "精算",
        '0x05' : "精算 (入場精算)",
        '0x06' : "窓出 (改札窓口処理)",
        '0x07' : "新規 (新規発行)",
        '0x08' : "控除 (窓口控除)",
        '0x0d' : "バス (PiTaPa系)",
        '0x0e' : "バス (IruCa系)",                 // 15
        '0x11' : "再発 (再発行処理)",              // 17
        '0x13' : "支払 (新幹線利用)",              // 19
        '0x14' : "入A (入場時オートチャージ)",     // 20
        '0x15' : "出A (出場時オートチャージ)",     // 21
        '0x1f' : "入金 (バスチャージ)",            // 31
        '0x23' : "券購 (バス路面電車企画券購入)",  // 35
        '0x46' : "物販",                           // 70
        '0x48' : "特典 (特典チャージ)",            // 72
        '0x49' : "入金 (レジ入金)",                // 73
        '0x4a' : "物販取消",                       // 74
        '0x4b' : "入物 (入場物販)",                // 75
        '0xc6' : "物現 (現金併用物販)",            // 198
        '0xcb' : "入物 (入場現金併用物販)",        // 203
        '0x84' : "精算 (他社精算)",                // 132
        '0x85' : "精算 (他社入場精算)",            // 133
      }
    }
    return suica[type][num.toLocaleLowerCase()]
  }
  splitStringToByteArray(str=null) {
    return str.match(/.{2}/g)
  }
  convToHexString(num='0') {
    let _out = []
    num.forEach( digit => {
      _out.push(('00' + digit.toString(16)).substr(-2))
    } )
    return _out
  }

  async init(ackTimeout = 500, receiveTimeout=500, autoBaudRate=true, autoDeviceSelect=true) {
    this.ackTimeout = ackTimeout
    this.receiveTimeout = receiveTimeout
    this.autoBaudRate = autoBaudRate
    this.autoDeviceSelect = autoDeviceSelect
    let config = new Configuration(this.ackTimeout, this.receiveTimeout,
                                   this.autoBaudRate, this.autoDeviceSelect);

    if(Object.keys(this.stationData).length == 0) {
      await this._fetchStationData()
    }

    await this.lib.init(config)
  }

  async open() {
    let result = {
      success: false,
    }
    try {
      await this.lib.open()
    } catch(err) {
      //console.log('err open:', this.lib, err)
      return result
    }
    result.success = true
    return result
  }

  async close() {
    await this.lib.close()
  }

  async detectCard() {
    let detectOption = new DetectionOption(new Uint8Array([0xff, 0xff]), 0, true, false, null);
    let result = {
      success: false,
      data: {}
    }
    try {
      let response = await this.lib.detectCard(this.card_type, detectOption)
      this.idm = response.idm
      this.pmm = response.pmm
      this.systemcode = response.systemCode
      if( response.systemCode[0] == 0x00 && response.systemCode[1] == 0x03) {
        this.pupi = response.pupi
        this.baudrate = response.baudRate ? response.baudRate : this.lib.targetCardBaudRate
        result = {
          success: true,
          data: {
            idm: NFCUtils.array_tohexs(this.idm),
            pmm: NFCUtils.array_tohexs(this.pmm),
            systemcode: (this.systemcode != null) ? NFCUtils.array_tohexs(this.systemcode) : null,
            baudrate: this.targetCardBaudRate
          }
        }
      } else {
        result = {
          success: false,
          data: {
            error_code: 'NOT_CJRC',
            msg: 'SystemCode is not CJRC standard',
            raw: response
          }
        }
      }
    } catch(err) {
      result.data = {
        success: false,
        data: {
          msg: 'Card was not detected.',
          raw: err
        }
      }
    }
    return result
  }

  /***
   * [iOSでSuicaの履歴を読み取る - Qiita]
   *    https://qiita.com/m__ike_/items/7dc3e643396cf3381167
   *
   *  [[PASMO] FeliCa から情報を吸い出してみる - FeliCaの仕様編 [Android][Kotlin] - Qiita]
   *    https://qiita.com/YasuakiNakazawa/items/3109df682af2a7032f8d#felica-%E3%81%A8%E3%81%AE%E9%80%9A%E4%BF%A1%E3%81%AE%E6%B5%81%E3%82%8C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6
   *
   * [AndroidのNFCでSuicaの履歴を読んでみる - Qiita]
   *    https://qiita.com/kurotsu/items/f351815ec6a65294ce0f
   *
   * << Read Without Encryption コマンド Format >>
   *  (0xXX)            //  1 byte: データ長バイト
   *  (0x06)            //  1 byte: コマンド「Read Without Encryption」
   *  (idm)             //  8 byte: IDm
   *  (1=m)             //  1 byte: サービスコードリストの長さ(1 <= m <= 16)
   *  (serviceCode)     // 2m byte: 利用履歴のサービスコード [0F 90] (2m)
   *  (block num)       //  1 byte: ブロック数
   *  (block list elem) //  N byte: (2n <= N <= 3n)
   **/
  async getAllCardHistory(history_num = 20) {
    const getHistoryRequest = (blocknum, from = 0) => {
      let data = []
      for ( var i = 0; i < blocknum; i++) {
        data = data.concat([ 0x80, i + from ])
      }
      return data;
    }

    const retrive_card_data = async (request, detectOption) => {
      let result = {
        success: false,
        data: {}
      }
      let res_result = {}
      try {
        let response = await this.lib.communicateThru(request, 100, detectOption)
        res_result = {
          request: NFCUtils.array_tohexs(request),
          response: NFCUtils.array_tohexs(response)
        }
        result.success = true
        result.data = res_result
      } catch(err) {
        //console.err('<><><><> ERROR HISTORY', err)
        //communicateTitle.innerText = 'Read error';
        result.success = false
        result.data = {
          msg: 'Read error',
          raw: err
        }
      }
      return result
    }

    let result = {
      success: false,
      data: {}
    }

    let size_max_each = 10
    let decoded_array = []

    for(let i=1; i<=2; i++) {
      // service code: 0x090f
      // [raspberry piでSuicaの履歴の表示 | TomoSoft]
      //   https://tomosoft.jp/design/?p=4991
      let detectOption = new DetectionOption(new Uint8Array([0xff, 0xff]), 0, true, false, null);
      let request = [ 0x06 ] // Read w/o Encryption
      let idm = []
      this.idm.forEach( d => {
        idm.push(d.toString())
      })
      request = request.concat(idm)
      request = request.concat([0x01, 0x0f, 0x09]) // service code
      request = request.concat([ size_max_each ])
      request = request.concat(getHistoryRequest(10, (i-1) * size_max_each ))
      request = ([request.length + 1]).concat(request)
      request = new Uint8Array(request)

      try {
        let read_result = await retrive_card_data(request, detectOption)
        if(read_result.success === false) {
          return read_result
        }

        let result_dec = await this.decodeResponse('history', read_result.data)
        if(result_dec.succcess == false) {
          return read_result
        }
        decoded_array = decoded_array.concat(result_dec.data.decoded)
      } catch(err) {
        result.success = false
        result.data = {
          msg: 'Read error',
          raw: err
        }
      }
    }
    result.success = true
    decoded_array.sort( (a, b) => {
      return b.seq_no - a.seq_no
    })
    result.data.decoded = decoded_array
    return result
  }

  // [suica - FeliCa Library Wiki - FeliCa Library - OSDN]
  //   https://osdn.net/projects/felicalib/wiki/suica
  // [OpenSCでSuicaの利用履歴を読む方法と履歴データのフォーマット解析 - Qiita]
  //   https://qiita.com/gebo/items/cb2dd393170767852fb3
  // [Suica他]
  //   http://jennychan.web.fc2.com/format/suica.html
  // type: String
  // raw : Object() { request: String, response: String }
  async decodeResponse(type = null, raw = null) {
    let result = {
      succcess: false,
      data: {
        raw: raw,
        decoded: {}
      },
      error: {
        msg: 'DEFAULT ERROR Message',
      }
    }

    if( type == null || raw == null ) {
      result.error.msg = `[PARAM NOT SET] type=[${type}] res_to_decode=[${res_to_decode}]`
      return result
    }

    let prefix = 0, p = []
    switch(type) {
      case 'balance' :
        prefix = 2 + 8 + 3
        prefix += 11
        let balance = 0
        p = this.splitStringToByteArray(raw.response).splice(prefix -1, 2)
        // little endian
        balance = parseInt('0x' + p[0] << 0) + parseInt('0x' + p[1] << 8)
        result.succcess = true
        result.data.decoded = { balance: balance }
        result.error.msg = null
        break
      case 'history' :
        prefix = 2 + 8 + 3
        p = this.splitStringToByteArray(raw.response)
        let count = 0
        let history_list = {
          raw: [],
          decoded: []
        }
        for(let i=0; i<20; i++) {
          if(p.length < 16 * (i + 1)) {
            break
          }
          history_list.raw.push(p.slice().splice(prefix + 16 * i, 16))
        }
        await history_list.raw.forEach( async (r, key) => {
          // 物販は時間も記録される
          let _time = null, _in_line = null, _in_station_order = null
          let _isBus = false, _isProductSale = false, _isCharge = false, _isTrain = false
          let _in_station = null, _out_station = null

          let _trans_type = r[0].toLocaleLowerCase()
          if(_trans_type == '05') {
            _isBus = true
          } else if(_trans_type == 'c7' || _trans_type == 'c8' ) {
            _isProductSale = true
            let time = parseInt('0x' + r[6] + r[7])
            let hh = ('00' + (time >> 11).toString()).substr(-2)
            let mm = ('00' + ((time >> 5) & 0x3f).toString()).substr(-2)
            _time = hh + ':' + mm
            //_in_station = await this.convertHexStationInfoToText(r[15], r[6], r[7])
          } else {
            if( r[1].toLocaleLowerCase() == '02') {
              _isCharge = true
              _in_station = await this.convertHexStationInfoToText(r[15], r[6], r[7])
            } else {
              _isTrain = true
              try {
                _in_station = await this.convertHexStationInfoToText(r[15], r[6], r[7])
                _out_station = await this.convertHexStationInfoToText(r[15], r[8], r[9])
              } catch(err) {
                console.error(err)
              }
            }
          }

          history_list.decoded.push({
            raw_hex_string: r.join(''),
            console_type: this.convertHexToString('machine', `0x${r[0]}`),
            console_is : {
              bus: _isBus,
              product_sale: _isProductSale,
              charge: _isCharge,
              train: _isTrain
            },
            transaction: this.convertHexToString('trans', `0x${r[1]}`),
            q00: [parseInt('0x'+r[2]), parseInt('0x'+r[3])],
            date: this.convertHextToDate([r[4], r[5]]),
            time: _time,
            in_line: _in_line,
            in_station_order: _in_station_order,
            in_station: _in_station,
            out_line: parseInt('0x'+r[8]),
            out_station_order: parseInt('0x'+r[9]),
            out_station: _out_station,
            balance: (parseInt('0x' + r[10]) << 0) + (parseInt('0x' + r[11]) << 8),
            seq_no: parseInt('0x' + r[12] + r[13] + r[14]),
            region: parseInt('0x'+r[15])
          })
        })
        result.succcess = true
        result.data.decoded = history_list.decoded
        result.error.msg = null
        //console.log('<><><><hhh>', history_list.decoded)
        break
    }

    return result
  }
}
